import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'

export const sharepointIntegration: PreviewIntegration = {
  id: 'sharepoint',
  name: 'Microsoft SharePoint',
  description:
    'Bring your SharePoint files to life—integrate files and shared content directly into Go.',
  icon: 'sharepoint-logo',
}
